import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localeHu from '@angular/common/locales/hu';
import { ApplicationConfig, InjectionToken, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import {
    DELIVERY_BACKEND_URL,
    LogLevel,
    provideBreadCrumbConfig,
    provideCookieConfig,
    provideIntroductionConfig,
    provideLanguageConfig,
    provideLoadingOverlay,
    provideNavigationConfig,
    provideSharedConfig,
    provideTranslationConfig
} from '@prekog/common-ui';
import { AppConfigService } from './core/config/app-config.service';
import { routes } from './app.routes';

registerLocaleData(localeHu, 'hu-HU', localeHuExtra);
export const STORE_BACKEND_URL = new InjectionToken<string>('STORE_BACKEND_URL');
export const ORDER_BACKEND_URL = new InjectionToken<string>('ORDER_BACKEND_URL');
export const CONFIGURATOR_BASE_URL = new InjectionToken<string>('CONFIGURATOR_BASE_URL');

export function createAppConfig(): ApplicationConfig {
    const configService = new AppConfigService();
    const config = configService.config;
    const consentExpiredTime = new Date(Date.now() + (config.consentExpiredDays * 24 * 60 * 60 * 1000));

    return {
        providers: [
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideHttpClient(withInterceptorsFromDi()),
            provideLoadingOverlay(),
            { provide: LOCALE_ID, useValue: 'hu-HU' },
            { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
            { provide: MAT_DIALOG_DATA, useValue: {} },
            { provide: 'ORDER_BACKEND_URL', useValue: config.backendOrderUrl },
            { provide: ORDER_BACKEND_URL, useValue: config.backendOrderUrl },
            { provide: STORE_BACKEND_URL, useValue: config.backendStoreUrl },
            { provide: DELIVERY_BACKEND_URL, useValue: config.backendDeliveryUrl },
            { provide: 'STORE_BACKEND_URL', useValue: config.backendStoreUrl },
            { provide: 'AUTH_BACKEND_URL', useValue: config.backendAuthUrl },
            { provide: CONFIGURATOR_BASE_URL, useValue: config.backendConfiguratorUrl },
            { provide: 'CONFIGURATOR_BASE_URL', useValue: config.backendConfiguratorUrl },
            { provide: 'API_URL', useValue: config.apiUrl },
            { provide: 'DOWNLOAD_FILE_URL', useValue: config.downloadUrl },
            { provide: 'PRODUCTION', useValue: config.production },
            { provide: 'FILE_BACKEND_URL', useValue: config.fileBaseUrl },
            { provide: 'FILE_MANAGER_URL', useValue: config.fileBaseUrl },
            { provide: 'PUBLIC_UI_URL', useValue: config.apiUrl },
            { provide: 'EMAIL_BACKEND_URL', useValue: config.backendEmailUrl },
            { provide: DatePipe },
            Meta,
            provideAnimationsAsync(),
            provideSharedConfig({
                logLevel: config.logLevel,
                enableUseCaseStatusLogs: config.enableUseCaseStatusLogs,
                logExpirationDays: config.logExpirationDays
            }),
            provideTranslationConfig({ translatedLanguages: ['hu'] }),
            provideLanguageConfig({}),
            provideBreadCrumbConfig({}),
            provideIntroductionConfig({}),
            provideCookieConfig({ consentExpiredTime: consentExpiredTime }),
            provideNavigationConfig({}),
            provideRouter(
                routes,
                withComponentInputBinding(),
                withInMemoryScrolling({
                    scrollPositionRestoration: 'top',
                    anchorScrolling: 'enabled'
                })
            )
        ]
    };
}
